import { gql } from '@strava/api/gql-client';

/* eslint-disable import/prefer-default-export */
export const linkableClubsQuery = gql`
  query EmbedModalLinkableClubsQuery {
    me {
      id
      clubs(isAdmin: true) {
        nodes {
          id
          name
        }
      }
    }
  }
`;
